import { Injectable } from "@angular/core";
import { getTeamMemberLocations, GetTeamMemberLocationsData, GetTeamMemberLocationsVariables } from "@dataconnect/account";
import { LocationPrivate, LocationPublic } from "../../../globalTypes/account.types";

@Injectable({
  providedIn: 'root'
})
export class VerifiedLocationService {
  constructor(

  ) {}

  // isLocationVerified(location: LocationPrivate): boolean {
  //   return location?.verified === true;
  // }

  async getTeamMembers(location: LocationPrivate): Promise<GetTeamMemberLocationsData['locations']>{
    const vars: GetTeamMemberLocationsVariables = {
      locationId: location.id,
      physicalAddressId: location.physicalAddress.id,
    }
    const teamMembersRef = await getTeamMemberLocations(vars);
    const teamMembers: GetTeamMemberLocationsData['locations'] = teamMembersRef.data.locations as GetTeamMemberLocationsData['locations'];
    return teamMembers;
  }
}